import { enderecoStep, DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL } from '../../shared/enderecoSections';
import { termosStep } from '../../shared/termosSections';
import { mergeDadosRequerimentoConfig } from '../../../core/services/dadosRequerimentoConfigUtils';

const pedidoAnotacaoImpedimentoConfig = {
  id: 'pedido_AnotacaoImpedimento',
  nome: 'Pedido de Anotação de Impedimento',
  categoria: 'inscricao',
  descricao: 'Solicitação de anotação de impedimento',
  icon: 'FaTrashAlt',

  documentConfig: {
    required: [
      { 
        id: 'requerimento', tipoDocumentoProcesso: 433, 
        name: 'Requerimento', 
        description: 'Requerimento preenchido e assinado digitalmente', 
        required: true 
      },
      {
        id: 'TermoPosse', tipoDocumentoProcesso: 378,
        name: 'Termo de Posse',
        description: 'Documento essencial para comprovação do motivo da anotação',
        required: true
      }
    ],
  },

  paymentConfig: {
    amount: 217.00
  },

  protocoloConfig: {
    modeloRequerimento: '246',
    tiposAssunto: '154',
    tipoPedido: '285'
  },

  dadosRequerimentoConfig: mergeDadosRequerimentoConfig(
    {
      campos: [
        { field: 'nomeCompleto', campoNome: 'Nome' },
        { field: 'cpf', campoNome: 'CPFCNPJ' }
      ]
    },
    DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL
  ),

  tituloConfig: {
    tipoLancamentoId: 115,
    enderecoOrigem: 'residencial'
  },

  steps: [
    {
      id: 'dados_pessoais',
      title: 'Dados Pessoais',
      sections: [
        {
          title: 'Identificação do Requerente',
          fields: [
            { 
              type: 'text', 
              name: 'nomeCompleto', 
              label: 'Nome completo', 
              required: true, 
              placeholder: 'Digite seu nome completo' 
            },
            { 
              type: 'cpf', 
              name: 'cpf', 
              label: 'CPF', 
              required: true 
            }
          ]
        },
      ]
    },
    enderecoStep({ autoCep: true }),
    termosStep()
  ]
};

export default pedidoAnotacaoImpedimentoConfig;